import React from "react";
import Login from "../../component/Auth/Login";

function LoginPage() {
  return <Login />;
}

export default LoginPage;
